import messages from "./content-type-messages";
import { MAPPING_KEYS } from "../../../constants";

const findContentType = (contentTypeKey, contentTypeEntries) =>
  contentTypeEntries.find(
    currentKey => currentKey.toLowerCase() === contentTypeKey.toLowerCase()
  );

// helper: converts kebab-case or snake_case to camelCase
const toCamelCase = key =>
  key.replace(/[-_](\w)/g, (_, char) => char.toUpperCase());

/**
 * Transforms API metadata keys (e.g., "saved-records", "saved-searches") into camelCase ("savedRecords", "savedSearches") and formats them, so they line up with
 * the message keys.
 */
export const normalizeMetadata = (apiMetadata = {}) =>
  Object.entries(apiMetadata).reduce((acc, [key, value]) => {
    //Map new UI kebab-case alert fields to camelCase (e.g., "alerts-journal" → "journalAlerts")
    if (key === MAPPING_KEYS.ALERTS_JOURNAL_KEY) {
      acc[MAPPING_KEYS.JOURNAL_ALERTS_KEY] = value;
    } else if (key === MAPPING_KEYS.ALERTS_SEARCH_KEY) {
      acc[MAPPING_KEYS.SEARCH_ALERTS_KEY] = value;
    } else if (
      // For all other keys: Convert them to camelCase, but skip classic UI alert fields (i.e., "journalAlerts" or "searchAlerts") to avoid overwriting new-ui values.
      // If API sends both "alerts-journal" AND "journalAlerts",the new UI value (alerts-journal) wins and classic value is ignored.
      key !== MAPPING_KEYS.JOURNAL_ALERTS_KEY &&
      key !== MAPPING_KEYS.SEARCH_ALERTS_KEY
    ) {
      acc[toCamelCase(key)] = value;
    }
    return acc;
  }, {});

/**
 * Maps an item of personalized content to a translation message with the count of that item in the values prop
 * @param {object} accountContent - Object containing items for that account that can be merged
 * @returns {array} Array of mapped translation messages
 */
const mapAccountContentToMessages = (accountContent = {}) => {
  const normalizedAccountContent = normalizeMetadata(accountContent);
  const messageKeys = Object.keys(messages);

  return Object.entries(normalizedAccountContent).reduce(
    (accumulator, [contentTypeKey, contentTypeValue]) => {
      const mappedMessage =
        messages[findContentType(contentTypeKey, messageKeys)];

      if (mappedMessage && contentTypeValue > 0) {
        accumulator.push({
          ...mappedMessage,
          values: { count: contentTypeValue }
        });
      }
      return accumulator;
    },
    []
  );
};

export default mapAccountContentToMessages;
